import merge from 'lodash/merge'

import es from '@shared/i18n/locales/es'

export default merge(es, {
  pt: {
    tracker: {
      _: 'Seguimiento',
      log: 'Iniciar sesión',
      intro:
        'Bienvenido al rastreador. Puede visitar esto en cualquier momento tocando el botón de seguimiento, y desde aquí puede realizar un seguimiento de usted mismo y ver los datos anteriores que haya ingresado.',
      columns: {
        time: 'Created at',
      },
      sign: {
        signed: 'Signed',
      },
      resultText: 'Thanks for submission!',
      resultAgain: 'Log again',
    },

    help: {
      _: 'Ayuda',
      title: 'Si tiene una emergencia, llame al 911 de inmediato.',
      newConversation: 'Nueva conversación',
      seeAllConversations: 'Ver la lista de todas las conversaciones',
    },

    messages: {
      errors: {
        auth: 'Falló la autenticación. Un enlace es incorrecto o ha caducado',
        linkExpired: 'el link ha expirado',
        unableToJoinCall: 'Unable to join the call',
        geolocationFailed:
          'Falló la adquisición de la información de geolocalización. Complete manualmente.',
      },

      warnings: {
        disagree:
          'No está de acuerdo con los términos y condiciones y no puede continuar con la conversación. Si desea cambiar su decisión, actualice la página y vuelva a intentarlo.',
      },
    },

    labels: {
      writeReply: 'Escribe una respuesta',
      noConversations: 'No hay conversaciones asignadas',
      humansOnly: 'Solo con humanos',
      viewTracker: 'Ver rastreador',
      tac: 'Términos y condiciones',
      click: 'O haga clic',
      here: 'aquí',
      goBack: 'para volver',
      viewOlder: 'Ver conversaciones más antiguas',
      pickAddress: 'Pick address',
      currentLocation: 'Current location',
      submitAddress: 'Submit Address',
      streetAddress: 'Street Address',
      zipCode: 'Zip Code',
      fillInTheForm: 'Fill in the form',
      chooseDate: 'Choose a date',
      poweredByQliqSoft: 'Powered by QliqSOFT',
    },
  },
})
